import type { PathConfig } from '@react-navigation/native';
import { groupMembersLinking } from 'app/screens/groups/group-members.linking';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/billboard',
  screens: {
    'landing-page': '/landing-page',
    'all-listings': '/all',
    'neighbour-listings': '/neighbour/:userId/:type',
    'neighbour-profile': '/neighbour/:userId',
    'one-listing': '/:id',
    'listing-activity': '/activity/:listingId',
    ratings: '/ratings',
    'grouped-listing': '/grouped/:id',
    'group-members': groupMembersLinking,
    'one-channel': '/chat/:url',
    presentPartageClub: '/present-partage-club',
    onboardingIntro: '/onboardingIntro',
  },
};

export const listingLinking: PathConfig<Parameters> = {
  path: '/listingModal',
  screens: {
    'one-listing': '/:id',
    'listing-activity': '/activity/:listingId',
    ratings: '/ratings',
    'grouped-listing': '/grouped/:id',
    'neighbour-listings': '/neighbour/:userId/:type',
    'neighbour-profile': '/neighbour/:userId',
    'one-channel': '/chat/:url',
    'loan-dates-picker': '/chat/:url/dates',
  },
};

export const userProfileLinking: PathConfig<Parameters> = {
  path: '/userProfileModal',
  screens: {
    'my-information': '/my-information',
    'neighbour-profile': '/neighbour/:userId',
    ratings: '/ratings',
    'neighbour-listings': '/neighbour/:userId/:type',
    'one-listing': '/:id',
    'listing-activity': '/activity/:listingId',
    'one-channel': '/chat/:url',
  },
};

export const newAddressLinking: PathConfig<Parameters> = {
  path: '/address',
  screens: {
    'my-neighbourhood': '/my-neighbourhood/',
  },
};
